import { showFullOptions } from 'owa-options-orchestration';
import { mountOptionsFullPopup } from '../components/full/OptionsFull';
import { getStore } from 'owa-options-store';

export default function mountAndShowFullOptions(
    category?: string,
    subcategory?: string,
    option?: string
) {
    let wasPreviouslyShown = getStore().isFullOptionsShown;
    showFullOptions(category, subcategory, option);

    if (!wasPreviouslyShown) {
        mountOptionsFullPopup();
    }
}
